
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcDepthActual as ObcDepthActualElement} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/depth-actual/depth-actual.js';
 
 
 

 
 export const ObcDepthActual = createComponent({
   react: React,
   tagName: 'obc-depth-actual',
   elementClass: ObcDepthActualElement,
   events: {
     
   }
  });
 
 